import { Component, Input } from '@angular/core';

import { ComponentType }    from '../../../../shared/components/components.utils';
import { ButtonComponent }  from '../../../../shared/components/buttons/button.component'
import { LogoComponent }    from '../../../../shared/components/logo/logo.component';

@Component({
  selector: 'pin-registration-side',
  templateUrl: './registration-side.component.html',
  styleUrls: ['./registration-side.component.scss'],
  imports: [LogoComponent, ButtonComponent]
})
export class RegistrationSideComponent {
  @Input()
  customClass: string;

  logoType = ComponentType;
}
